// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/globe.js';

import { paths } from '../generated/globe';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('globe', Original, paths);
